import {
  DASHBOARD_FEATURES,
  SITE_PAGES,
  allPermissions,
  emptyPermissions,
  setAllPageSections,
  setDashboardPermission,
  setPageAccess,
  setSectionPermission,
} from "../../lib/permissions";

export function PermissionMatrix({ value, onChange, disabled }) {
  return (
    <div className="rounded-2xl border border-black/10 overflow-hidden">
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 bg-black/[0.03] border-b border-black/10">
        <div>
          <p className="text-sm font-medium">Roles and permissions</p>
          <p className="text-xs text-black/50 mt-0.5">
            Tick dashboard areas this admin can open, then tick which website contents they may edit.
          </p>
        </div>
        {!disabled && (
          <div className="flex gap-2">
            <button type="button" className="text-xs px-3 py-1.5 rounded-full border border-black/15" onClick={() => onChange(allPermissions())}>
              Allow all
            </button>
            <button type="button" className="text-xs px-3 py-1.5 rounded-full border border-black/15" onClick={() => onChange(emptyPermissions())}>
              Clear
            </button>
          </div>
        )}
      </div>

      <div className="px-4 py-3 border-b border-black/10">
        <p className="font-mono text-[11px] uppercase tracking-widest text-black/40 mb-3">Dashboard</p>
        <div className="space-y-2">
          {DASHBOARD_FEATURES.map((feature) => (
            <div key={feature.key} className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-black/8 px-3 py-2">
              <div>
                <p className="text-sm font-medium">{feature.label}</p>
                <p className="text-xs text-black/50">{feature.hint}</p>
              </div>
              <div className="flex items-center gap-4">
                {feature.actions.map((action) => (
                  <label key={action} className="flex items-center gap-2 text-xs capitalize text-black/70">
                    <input
                      type="checkbox"
                      checked={Boolean(value?.[feature.key]?.[action])}
                      disabled={disabled}
                      onChange={(e) => onChange(setDashboardPermission(value, feature.key, action, e.target.checked))}
                    />
                    {action}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="px-4 py-3">
        <p className="font-mono text-[11px] uppercase tracking-widest text-black/40 mb-3">Website pages & contents</p>
        <div className="space-y-3">
          {SITE_PAGES.map((page) => {
            const pagePerms = value?.pages?.[page.key] || { access: false, sections: {} };
            return (
              <div key={page.key} className="rounded-xl border border-black/8 overflow-hidden">
                <div className="flex flex-wrap items-center justify-between gap-3 px-3 py-2 bg-black/[0.03]">
                  <label className="flex items-center gap-2 text-sm font-medium">
                    <input
                      type="checkbox"
                      checked={Boolean(pagePerms.access)}
                      disabled={disabled}
                      onChange={(e) => onChange(setPageAccess(value, page.key, e.target.checked))}
                    />
                    {page.label} page
                  </label>
                  {!disabled && (
                    <button
                      type="button"
                      className="text-xs text-[#EC4899] hover:underline"
                      onClick={() => onChange(setAllPageSections(value, page.key, true))}
                    >
                      All contents
                    </button>
                  )}
                </div>
                <div className="divide-y divide-black/5">
                  {page.sections.map((section) => {
                    const sectionPerms = pagePerms.sections?.[section.key] || {};
                    return (
                      <div key={section.key} className="flex flex-wrap items-center justify-between gap-3 px-3 py-2">
                        <p className="text-sm text-black/80">{section.label}</p>
                        <label className="flex items-center gap-2 text-xs text-black/70">
                          <input
                            type="checkbox"
                            checked={Boolean(sectionPerms.edit)}
                            disabled={disabled}
                            onChange={(e) =>
                              onChange(setSectionPermission(value, page.key, section.key, "edit", e.target.checked))
                            }
                          />
                          edit
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
